import clsx from 'clsx';
import PropTypes from 'prop-types';

export default function ProgressSteps({ completed, steps }) {
    if (steps <= 0) return null;

    return (
        <div className="flex w-full justify-between gap-10" title="Progress Indicator">
            {Array(steps)
                .fill(undefined)
                .map((_, index) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        className={clsx('flex h-[6px] flex-1 rounded-full', {
                            'bg-mango': index + 1 <= completed,
                            'bg-grey-light': !(index + 1 <= completed),
                        })}
                    />
                ))}
        </div>
    );
}

ProgressSteps.propTypes = {
    completed: PropTypes.number.isRequired,
    steps: PropTypes.number.isRequired,
};
